'use strict';

window.updateCartBadges = (count) => {
    if (count == null || count === '') {
        window.dispatchEvent(new Event('cart-updated'));
        return;
    }
    const text = String(count);
    const num = parseFloat(String(count).replace(',', '.')) || 0;
    const header = document.querySelector('.header__cart-badge');
    if (header) header.textContent = text;
    const bottom = document.querySelector('.bottom-bar__badge');
    if (bottom) {
        bottom.textContent = text;
        if (num > 0) bottom.removeAttribute('hidden');
        else bottom.setAttribute('hidden', '');
    }
    window.dispatchEvent(new Event('cart-updated'));
};

document.addEventListener('alpine:init', () => {

    // ── Wishlist store (cookie: shop_favorite — Shop-Script standard) ────────
    Alpine.store('wishlist', {
        ids: (() => {
            try {
                const c = document.cookie.match(/shop_favorite=([^;]*)/);
                return c ? c[1].split(',').filter(Boolean) : [];
            } catch { return []; }
        })(),
        has(id) { return this.ids.includes(String(id)); },
        save() { document.cookie = `shop_favorite=${this.ids.join(',')}; path=/; max-age=31536000`; },
        toggle(id, img, name) {
            const sid = String(id);
            const type = this.ids.includes(sid) ? 'wishlist-remove' : 'wishlist-add';
            this.ids = type === 'wishlist-remove'
                ? this.ids.filter(x => x !== sid)
                : [...this.ids, sid];
            this.save();
            window.dispatchEvent(new CustomEvent('cart-toast', { detail: { img, name, type, pid: sid } }));
        },
    });

    // ── Compare store (cookie: shop_compare — Shop-Script standard) ──────────
    Alpine.store('compare', {
        ids: (() => {
            const c = document.cookie.match(/shop_compare=([^;]*)/);
            return c ? [...new Set(c[1].split(',').filter(Boolean))] : [];
        })(),
        _path: window.__THEME__?.compareUrl?.replace(/compare\/?$/, '') || '/',
        has(id) { return this.ids.includes(String(id)); },
        save() {
            document.cookie = `shop_compare=${this.ids.join(',')}; path=${this._path}; max-age=31536000`;
        },
        compareUrl() {
            const base = window.__THEME__?.compareUrl || '/compare/';
            return this.ids.length ? base.replace(/\/?$/, '/') + this.ids.join(',') + '/' : base;
        },
        toggle(id, img, name) {
            const sid = String(id);
            const type = this.ids.includes(sid) ? 'compare-remove' : 'compare-add';
            this.ids = type === 'compare-remove'
                ? this.ids.filter(x => x !== sid)
                : [...new Set([...this.ids, sid])];
            this.save();
            window.dispatchEvent(new CustomEvent('cart-toast', { detail: { img, name, type, pid: sid } }));
        },
    });

    // ── Quick View store ─────────────────────────────────────────────────────
    Alpine.store('quickView', {
        isOpen:  false,
        loading: false,

        open(url) {
            this.isOpen  = true;
            this.loading = true;
            document.body.classList.add('qv-open');
            const el = document.getElementById('qv-content');
            el.innerHTML = '';
            const u = new URL(url, location.origin);
            u.searchParams.set('cart', '1');
            fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                .then(r => r.text())
                .then(html => {
                    const tmp = document.createElement('div');
                    tmp.innerHTML = html;
                    // Execute inline scripts (sets window.__PRODUCT__)
                    tmp.querySelectorAll('script').forEach(s => {
                        const script = document.createElement('script');
                        script.textContent = s.textContent;
                        document.head.appendChild(script);
                        document.head.removeChild(script);
                        s.remove();
                    });
                    el.innerHTML = tmp.innerHTML;
                    Alpine.initTree(el);
                    // Init QV gallery Swiper — deferred so the dialog transition finishes
                    // and Swiper can measure real dimensions
                    requestAnimationFrame(() => {
                        const qvMain = el.querySelector('#qv-gallery-main');
                        const qvThumbs = el.querySelector('#qv-gallery-thumbs');
                        if (qvMain && typeof Swiper !== 'undefined') {
                            let qvThumbsSwiper = null;
                            if (qvThumbs) {
                                qvThumbsSwiper = new Swiper(qvThumbs, {
                                    spaceBetween: 8,
                                    slidesPerView: 'auto',
                                    watchSlidesProgress: true,
                                    freeMode: true,
                                });
                            }
                            const qvCounter = el.querySelector('.qv-gallery__counter-current');
                            const updateQvCounter = sw => {
                                if (qvCounter) qvCounter.textContent = (sw.activeIndex || 0) + 1;
                            };
                            new Swiper(qvMain, {
                                spaceBetween: 0,
                                slidesPerView: 1,
                                observer: true,
                                observeParents: true,
                                navigation: {
                                    prevEl: el.querySelector('.qv-gallery__nav--prev'),
                                    nextEl: el.querySelector('.qv-gallery__nav--next'),
                                },
                                thumbs: qvThumbsSwiper ? { swiper: qvThumbsSwiper } : undefined,
                                on: {
                                    init: updateQvCounter,
                                    slideChange: updateQvCounter,
                                },
                            });
                        }
                    });
                    this.loading = false;
                })
                .catch(() => { this.loading = false; });
        },

        close() {
            this.isOpen = false;
            document.body.classList.remove('qv-open');
            setTimeout(() => {
                if (!this.isOpen) document.getElementById('qv-content').innerHTML = '';
            }, 300);
        },
    });

    // ── Product tabs store (home page products section) ─────────────────────
    Alpine.store('prodTabs', {
        active: '',
        _initialized: new Set(),

        init() {
            const def = document.querySelector('[data-tab-default]');
            this.active = def ? def.dataset.tab : 'tab1';
        },

        switchTo(tabId) {
            if (this.active === tabId) return;
            this.active = tabId;

            // Init or update Swiper for new tab
            requestAnimationFrame(() => {
                const nav = document.querySelector('.h-prods-nav');
                const prevBtn = nav ? nav.querySelector('.h-prods-nav__prev') : null;
                const nextBtn = nav ? nav.querySelector('.h-prods-nav__next') : null;

                // В tabs_mode кнопки навигации общие на все вкладки.
                // Отвязываем nav у всех неактивных свайперов, иначе их внутреннее
                // состояние (disabled class + клики) перекрывает активный.
                document.querySelectorAll('.h-prods-wrap[data-tab]').forEach((w) => {
                    const s = w.querySelector('.h-prods-grid__swiper')?.swiper;
                    if (s && s.navigation && w.dataset.tab !== tabId) {
                        try { s.navigation.destroy(); } catch (_) {}
                    }
                });

                const wrap = document.querySelector(`.h-prods-wrap[data-tab="${tabId}"]`);
                const el = wrap?.querySelector('.h-prods-grid__swiper');
                if (el) {
                    const sw = el.swiper;
                    if (sw) {
                        // Переподключаем навигацию к активному свайперу
                        if (prevBtn && nextBtn && sw.params.navigation) {
                            sw.params.navigation.prevEl = prevBtn;
                            sw.params.navigation.nextEl = nextBtn;
                            try { sw.navigation.destroy(); } catch (_) {}
                            sw.navigation.init();
                            sw.navigation.update();
                        }
                        sw.update();
                        if (nav) nav.classList.toggle('is-hidden', sw.isLocked);
                    } else if (window.__initProdSwiper) {
                        if (nav) nav.classList.remove('is-hidden');
                        window.__initProdSwiper(el, nav);
                    }
                } else if (nav) {
                    nav.classList.add('is-hidden');
                }
            });
        },
    });

    // ── App shell (header + catalog + cart + mobile search) ──────────────────
    Alpine.data('appShell', () => ({
        catalogOpen:   false,
        activeCat:     window.__THEME__?.initCat ?? 0,
        catLabels:     window.__THEME__?.catLabels ?? {},
        cartOpen:      false,
        cartTimer:     null,
        cartLoaded:    false,
        cartLoading:   false,
        mobileCatOpen: false,
        searchOpen:    false,
        searchQuery:   '',
        mobileSearchCat: '',
        dropdownTop:   68,
        headerSticky:  false,
        mobileHistory: [],
        mobileHistoryClearing: false,
        popularQueries: [],

        init() {
            this.popularQueries = (window.__THEME__?.popularQueries || '')
                .split(',').map((s) => s.trim()).filter(Boolean);
            this.mobileHistory = this._loadSearchHistory();
            this.mobileSearchCat = new URLSearchParams(location.search).get('category') || '';

            this.$watch('catalogOpen', (val) => {
                this.updateBodyScrollLock();
                if (!val) this.mobileCatOpen = false;
                if (val) {
                    const header = document.querySelector('.header');
                    if (header) {
                        this.dropdownTop = header.getBoundingClientRect().bottom;
                    }
                }
            });
            this.$watch('cartOpen', (val) => {
                if (!val && this.$refs.cartBtn === document.activeElement) {
                    this.$refs.cartBtn.blur();
                }
            });
            window.addEventListener('cart-updated', () => this.invalidateCart());

            window.addEventListener('search-history-updated', () => {
                this.mobileHistory = this._loadSearchHistory();
            });
            this.$watch('searchOpen', (val) => {
                this.updateBodyScrollLock();
                if (val) {
                    this.mobileHistory = this._loadSearchHistory();
                    this.$nextTick(() => this.$refs.mobileSearchInput?.focus());
                }
            });

        },

        appHeaderBack() {
            let sameOriginReferrer = false;
            if (document.referrer) {
                try {
                    sameOriginReferrer = new URL(document.referrer).origin === window.location.origin;
                } catch (e) {
                    sameOriginReferrer = false;
                }
            }
            if (window.history.length > 1 && sameOriginReferrer) {
                window.history.back();
            } else {
                window.location.href = '/';
            }
        },

        get hasMobileHistory() {
            return this.mobileHistory.length > 0;
        },

        mobileSearchUrl(query) {
            const form = this.$el.querySelector('.mobile-search form');
            const base = form?.getAttribute('action') || '/search/';
            return `${base}?query=${encodeURIComponent(query).replace(/%20/g, '+')}`;
        },

        saveMobileSearch() {
            const query = this.searchQuery.trim();
            if (!query) return;
            const key = 'search_history';
            const max = 5;
            let history = [];
            try {
                history = JSON.parse(localStorage.getItem(key) || '[]');
            } catch {}
            history = history.filter((item) => item.toLowerCase() !== query.toLowerCase());
            history.unshift(query);
            history = history.slice(0, max);
            try { localStorage.setItem(key, JSON.stringify(history)); } catch {}
            this.mobileHistory = history;
        },

        clearMobileHistory() {
            if (this.mobileHistoryClearing) return;
            this.mobileHistoryClearing = true;
            setTimeout(() => {
                try { localStorage.removeItem('search_history'); } catch {}
                this.mobileHistory = [];
                this.mobileHistoryClearing = false;
                window.dispatchEvent(new Event('search-history-updated'));
            }, 280);
        },

        _loadSearchHistory() {
            try {
                const raw = localStorage.getItem('search_history');
                return raw ? JSON.parse(raw).slice(0, 5) : [];
            } catch {
                return [];
            }
        },

        updateBodyScrollLock() {
            document.body.style.overflow = (this.catalogOpen || this.searchOpen) ? 'hidden' : '';
        },

        onScroll() {
            // headerSticky + dropdownTop — задел под v2 (sticky-шапку).
            // Сейчас шапка не sticky → НЕ обновляем, иначе top:
            // getBoundingClientRect().bottom уезжает в отрицательные значения
            // и mega-dropdown уходит за пределы viewport.
            // Раскомментировать вместе с sticky в .header (см. header/_index.scss).
            // this.headerSticky = window.scrollY > 0;
            // if (this.catalogOpen) {
            //     const header = document.querySelector('.header');
            //     if (header) {
            //         this.dropdownTop = header.getBoundingClientRect().bottom;
            //     }
            // }
        },

        openCart() {
            clearTimeout(this.cartTimer);
            this.cartOpen    = true;
            this.catalogOpen = false;
            this.$nextTick(() => this.$refs.cartBtn?.focus({ preventScroll: true }));
            if (!this.cartLoaded && !this.cartLoading) {
                this.fetchCart();
            }
        },

        closeCartDelayed() {
            this.cartTimer = setTimeout(() => { this.cartOpen = false; }, 300);
        },

        async fetchCart() {
            const url = window.__THEME__?.cartUrl || '/cart/';
            this.cartLoading = true;
            try {
                const res = await fetch(`${url}?ajax=1`, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                });
                const html = await res.text();
                const body = this.$refs.cartBody;
                if (!body) return;
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const fragment = doc.getElementById('minicart-ajax');
                body.innerHTML = fragment ? fragment.innerHTML : html;
                this.cartLoaded = true;
                this.bindMiniCartEvents();
            } catch {
                // silent
            } finally {
                this.cartLoading = false;
            }
        },

        bindMiniCartEvents() {
            const body = this.$refs.cartBody;
            if (!body) return;
            body.querySelectorAll('.js-minicart-del').forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.removeCartItem(btn.dataset.id);
                });
            });
        },

        async removeCartItem(id) {
            if (this.cartLoading) return; // блокируем параллельные удаления
            const url = window.__THEME__?.cartUrl || '/cart/';
            const body = this.$refs.cartBody;
            const itemEl = body?.querySelector(`.cart-dropdown__item[data-id="${id}"]`);

            // Smooth collapse: фиксируем текущую высоту, затем запускаем transition
            if (itemEl) {
                itemEl.style.maxHeight = `${itemEl.offsetHeight}px`;
                void itemEl.offsetHeight; // force reflow
                itemEl.classList.add('is-removing');
            }

            this.cartLoading = true; // overlay поверх body до окончания callback
            try {
                const [res] = await Promise.all([
                    fetch(`${url}delete/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                        body: `html=1&id=${id}`,
                    }),
                    new Promise((resolve) => setTimeout(resolve, 280)),
                ]);
                const data = await res.json();
                window.updateCartBadges(data?.data?.count);
                // Rebuild mini-cart с уже свёрнутым элементом — обновит total и footer.
                // fetchCart сам управляет cartLoading (сбросит в false в finally).
                this.cartLoaded = false;
                await this.fetchCart();
            } catch {
                this.cartLoading = false;
            }
        },

        invalidateCart() {
            this.cartLoaded = false;
            if (this.cartOpen) this.fetchCart();
        },

        onEscape() {
            this.catalogOpen   = false;
            this.cartOpen      = false;
            this.searchOpen    = false;
        },
    }));

    // ── Desktop search wrap ───────────────────────────────────────────────────
    Alpine.data('searchWrap', () => ({
        searchOpen: false,
        searchCat: '',
        searchCatName: 'Везде',
        catOpen: false,
        hasQuery: false,
        liveResults: '',
        _liveTimer: null,
        _liveAbort: null,
        _liveEnabled: window.__THEME__?.liveSearch ?? false,
        _searchBase: window.__THEME__?.searchUrl || '/search/',
        history: [],
        historyClearing: false,
        popularQueries: [],
        _STORAGE_KEY: 'search_history',
        _MAX_ITEMS: 3,

        init() {
            this.popularQueries = (window.__THEME__?.popularQueries || '')
                .split(',').map((s) => s.trim()).filter(Boolean).slice(0, this._MAX_ITEMS);
            this.history = this._load();

            const params = new URLSearchParams(location.search);
            this.searchCat = params.get('category') || '';

            // Restore category name from popup options
            if (this.searchCat) {
                const opt = this.$el.querySelector(`.header__search-cat-option[\\@click*="'${this.searchCat}'"]`);
                if (opt) this.searchCatName = opt.textContent.trim();
            }

            // Check if input already has a value (e.g. search results page)
            const input = this.$refs.searchInput;
            if (input && input.value.trim()) this.hasQuery = true;

            const form = this.$el.querySelector('form');
            if (form) {
                form.addEventListener('submit', () => {
                    const query = input?.value.trim();
                    if (query) this._save(query);
                });
            }

            window.addEventListener('search-history-updated', () => {
                this.history = this._load();
            });

            this.$watch('searchCat', () => {
                const query = input?.value.trim();
                if (this._liveEnabled && query && query.length >= 2) {
                    clearTimeout(this._liveTimer);
                    this._fetchLive(query);
                }
            });

            window.addEventListener('resize', () => {
                if (this.searchOpen) this.close();
            });
        },

        get hasHistory() {
            return this.history.length > 0;
        },

        get hasPopular() {
            return this.popularQueries.length > 0;
        },

        open()  { this.searchOpen = true; this.catOpen = false; },
        close() { this.searchOpen = false; this.liveResults = ''; },

        toggleCat() {
            this.catOpen = !this.catOpen;
            if (this.catOpen) this.close();
        },

        selectCat(id, name) {
            this.searchCat = id;
            this.searchCatName = name;
            this.catOpen = false;
        },

        clearCat() {
            this.searchCat = '';
            this.searchCatName = 'Везде';
            this.catOpen = false;
        },

        clearQuery() {
            const input = this.$refs.searchInput;
            if (input) { input.value = ''; input.focus(); }
            this.hasQuery = false;
            this.liveResults = '';
        },

        onSearchInput(e) {
            const query = e.target.value.trim();
            this.hasQuery = query.length > 0;
            this.open();
            if (!this._liveEnabled) return;
            clearTimeout(this._liveTimer);
            if (query.length < 2) { this.liveResults = ''; return; }
            this._liveTimer = setTimeout(() => this._fetchLive(query), 300);
        },

        async _fetchLive(query) {
            if (this._liveAbort) this._liveAbort.abort();
            this._liveAbort = new AbortController();
            try {
                const params = new URLSearchParams({ query, view: 'ajax_search' });
                if (this.searchCat) params.set('category', this.searchCat);
                const resp = await fetch(`${this._searchBase}?${params}`, {
                    signal: this._liveAbort.signal,
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                });
                if (resp.ok) this.liveResults = await resp.text();
            } catch {}
        },

        searchUrl(query) {
            const form = this.$el.querySelector('form');
            const base = form?.getAttribute('action') || '/search/';
            return `${base}?query=${encodeURIComponent(query).replace(/%20/g, '+')}`;
        },

        clearSearchHistory() {
            if (this.historyClearing) return;
            this.historyClearing = true;

            setTimeout(() => {
                try { localStorage.removeItem(this._STORAGE_KEY); } catch {}
                this.history = [];
                this.historyClearing = false;
                window.dispatchEvent(new Event('search-history-updated'));
            }, 280);
        },

        _load() {
            try {
                const raw = localStorage.getItem(this._STORAGE_KEY);
                if (!raw) return [];
                const parsed = JSON.parse(raw);
                return Array.isArray(parsed) ? parsed.slice(0, this._MAX_ITEMS) : [];
            } catch {
                return [];
            }
        },

        _save(query) {
            const filtered = this.history.filter(
                (item) => item.toLowerCase() !== query.toLowerCase()
            );
            filtered.unshift(query);
            const updated = filtered.slice(0, this._MAX_ITEMS);

            try {
                localStorage.setItem(this._STORAGE_KEY, JSON.stringify(updated));
            } catch {}

            this.history = updated;
            window.dispatchEvent(new Event('search-history-updated'));
        },
    }));

    // ── Cookie consent bar ────────────────────────────────────────────────────
    Alpine.data('cookieBar', () => ({
        visible: !localStorage.getItem('cookie_accepted'),
        accept() {
            localStorage.setItem('cookie_accepted', '1');
            this.visible = false;
        },
    }));


    // ── Theme store ─────────────────────────────────────────────────────────
    Alpine.store('darkMode', localStorage.getItem('theme') === 'dark');

    // ── Theme switcher (dark / light) ─────────────────────────────────────────
    Alpine.data('themeSwitcher', () => ({
        get darkMode() { return Alpine.store('darkMode'); },
        set darkMode(val) { Alpine.store('darkMode', val); },

        init() {
            if (this.darkMode) document.documentElement.dataset.theme = 'dark';

            this.$watch('darkMode', (val) => {
                document.documentElement.dataset.theme = val ? 'dark' : 'light';
                localStorage.setItem('theme', val ? 'dark' : 'light');
            });
        },

        toggle() {
            this.darkMode = !this.darkMode;
        },
    }));

    // ── Catalog page ─────────────────────────────────────────────────────────
    Alpine.data('catalogPage', () => ({
        sortOpen:     false,
        sortDropOpen: false,
        sidebarSections: {},

        // ── Sort dropdown ──────────────────────────────
        toggleSortDrop() { this.sortDropOpen = !this.sortDropOpen; },
        closeSortDrop()  { this.sortDropOpen = false; },

        // ── View toggle (cookie + AJAX refresh) ──────────
        setView(v) {
            document.cookie = `show=${v}; path=/; max-age=31536000`;
            // Если catalog-ajax активен (есть фильтры) — обновляется через него,
            // иначе fallback на полный reload (категории без фильтров)
            const contentEl = document.getElementById('wa-content');
            if (contentEl && contentEl.querySelector('[data-catalog-filter]')) {
                document.dispatchEvent(new Event('catalog-refresh'));
            } else {
                location.reload();
            }
        },

        // ── Desktop sidebar sections ──────────────────────
        toggleSidebarSection(id) {
            this.sidebarSections[id] = !this.isSidebarSectionOpen(id);
        },

        isSidebarSectionOpen(id) {
            return this.sidebarSections[id] ?? true; // open by default
        },

        // ── Price range slider ─────────────────────────
        priceMin:  window.__CATALOG__?.priceMin ?? 0,
        priceMax:  window.__CATALOG__?.priceMax ?? 99999,
        priceFrom: window.__CATALOG__?.priceCurrentMin ?? (window.__CATALOG__?.priceMin ?? 0),
        priceTo:   window.__CATALOG__?.priceCurrentMax ?? (window.__CATALOG__?.priceMax ?? 99999),

        initPriceSlider() {
            // Keep values from GET params (window.__CATALOG__.priceCurrent*) and clamp.
            this.priceFrom = Number.isFinite(+this.priceFrom) ? +this.priceFrom : this.priceMin;
            this.priceTo   = Number.isFinite(+this.priceTo)   ? +this.priceTo   : this.priceMax;
            this.priceFrom = Math.max(this.priceMin, Math.min(this.priceFrom, this.priceMax));
            this.priceTo   = Math.max(this.priceMin, Math.min(this.priceTo, this.priceMax));
            if (this.priceFrom >= this.priceTo) {
                this.priceFrom = Math.max(this.priceMin, this.priceTo - 1);
            }
            this.$watch('priceFrom', () => this._updateTrack());
            this.$watch('priceTo',   () => this._updateTrack());
            this._updateTrack();
        },

        onPriceFrom(e) {
            const v = parseInt(e.target.value, 10);
            if (Number.isNaN(v)) return;
            this.priceFrom = Math.min(v, this.priceTo - 1);
        },

        onPriceTo(e) {
            const v = parseInt(e.target.value, 10);
            if (Number.isNaN(v)) return;
            this.priceTo = Math.max(v, this.priceFrom + 1);
        },

        _updateTrack() {
            const range = this.priceMax - this.priceMin || 1;
            const minPct = ((this.priceFrom - this.priceMin) / range * 100).toFixed(2) + '%';
            const maxPct = ((this.priceTo   - this.priceMin) / range * 100).toFixed(2) + '%';
            this.$refs.priceSlider?.style.setProperty('--min-pct', minPct);
            this.$refs.priceSlider?.style.setProperty('--max-pct', maxPct);
        },

        // ── Lazy pagination (IntersectionObserver) ─────
        initLazyPagination() {
            const sentinel = this.$refs.lazySentinel;
            if (!sentinel) return;
            const io = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) this.$dispatch('catalog-load-next');
            }, { rootMargin: '200px' });
            io.observe(sentinel);
            this._lazyObserver = io;
        },

        destroyLazyPagination() {
            this._lazyObserver?.disconnect();
        },
    }));

    // ── Active filters counter (для бейджа на кнопке «Фильтры») ──────────────
    Alpine.data('activeFiltersCount', () => ({
        count: 0,
        init() {
            this.recalc();
            this._onUpdate = () => this.recalc();
            window.addEventListener('catalog:updated', this._onUpdate);
            window.addEventListener('popstate', this._onUpdate);
        },
        destroy() {
            window.removeEventListener('catalog:updated', this._onUpdate);
            window.removeEventListener('popstate', this._onUpdate);
        },
        recalc() {
            const params = new URLSearchParams(window.location.search);
            const skip = new Set(['sort', 'order', 'page', 'view', 'query', 'category']);
            let c = 0;
            for (const [k, v] of params) {
                if (skip.has(k)) continue;
                if (!v) continue;
                c++;
            }
            this.count = c;
        },
    }));

    // ── Filter drawer (mobile/tablet) ─────────────────────────────────────────
    Alpine.data('filterDrawer', () => ({
        open:     false,
        sections: {},

        show() {
            this.open = true;
            document.body.style.overflow = 'hidden';
        },

        hide() {
            this.open = false;
            document.body.style.overflow = '';
        },

        toggleSection(id) {
            this.sections[id] = !(this.sections[id] ?? true);
        },

        isSectionOpen(id) {
            return this.sections[id] ?? true; // open by default
        },

        onEscape() { this.hide(); },
    }));

    // ── Nav overflow — hide items that don't fit ──────────────────────────────
    Alpine.data('navOverflow', () => ({
        init() {
            this.recalc();
            // Recalc once fonts are loaded (item widths can change after font swap)
            if (document.fonts?.ready) {
                document.fonts.ready.then(() => this.recalc()).catch(() => {});
            }
        },
        recalc() {
            const main = this.$refs.main;
            if (!main) return;

            const aside = this.$refs.aside; // может отсутствовать, если блок «Акция» выключен
            const items = main.querySelectorAll(':scope > .mega-nav__item');
            // show all first to measure
            items.forEach(el => el.style.display = '');

            const bgWidth = main.parentElement.clientWidth;
            const asideWidth = aside ? aside.offsetWidth : 0;
            // 4px buffer: защита от sub-pixel rounding и шрифтовых сдвигов
            const maxWidth = bgWidth - asideWidth - 4;

            let total = 0;
            items.forEach(el => {
                total += el.offsetWidth;
                el.style.display = total > maxWidth ? 'none' : '';
            });
        }
    }));

    // ── Cart qty (fractional step + debounced AJAX cart sync) ──────────────────
    // Theme setting `card_cart_qty`:
    //   true  → +/- controls with full cart sync (add → save/delete debounced)
    //   false → no +/- controls, button shows "В корзине" after first add
    Alpine.data('cartQty', (el) => {
        const min  = parseFloat(el.dataset.min  ?? 1);
        const max  = parseFloat(el.dataset.max  ?? 99);
        const step = parseFloat(el.dataset.step ?? 1);
        const dec  = (step.toString().split('.')[1] ?? '').length;
        const pid  = el.dataset.pid;
        const sku  = el.dataset.sku || '';
        const pName = el.dataset.name || '';
        const pImg  = el.dataset.img || '';
        const baseUrl = window.__THEME__?.cartUrl || '/cart/';
        const qtySync = window.__THEME__?.cardCartQty ?? true;
        const DEBOUNCE = 400;

        let syncTimer = null;

        return {
            qty: 0,
            min, max, step, dec,
            added: false,
            qtySync,
            itemId: null,
            maxReached: false,
            loading: false,

            add() {
                if (this.maxReached || this.loading) return;
                if (qtySync) {
                    const wasZero = this.qty === 0;
                    if (wasZero) {
                        this.qty = this.min;
                        if (pid) this.postAdd(this.min);
                    } else {
                        this.qty = parseFloat(Math.min(this.max, this.qty + this.step).toFixed(this.dec));
                        this.debounceSave();
                    }
                } else {
                    if (!this.added && pid) {
                        this.postAdd(this.min);
                    }
                }
            },

            sub() {
                if (!qtySync || this.loading) return;
                const n = parseFloat((this.qty - this.step).toFixed(this.dec));
                this.qty = n < this.min ? 0 : n;
                this.maxReached = false;
                this.debounceSave();
            },

            // Debounce: qty меняется мгновенно, запрос летит один после паузы
            debounceSave() {
                clearTimeout(syncTimer);
                syncTimer = setTimeout(() => {
                    if (!this.itemId) return;
                    if (this.qty <= 0) {
                        this.postDelete();
                    } else {
                        this.postSave(this.qty);
                    }
                }, DEBOUNCE);
            },

            // POST cart/add/ — первое добавление (получаем item_id)
            async postAdd(quantity) {
                const body = new URLSearchParams({
                    product_id: pid,
                    quantity: String(quantity),
                });
                if (sku) body.set('sku_id', sku);

                this.loading = true;
                try {
                    const res = await fetch(`${baseUrl}add/`, {
                        method: 'POST',
                        body,
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    });
                    if (res.ok) {
                        const data = await res.json().catch(() => null);
                        if (data?.status === 'fail') {
                            this.maxReached = true;
                            // Откатить qty если товар не добавился
                            if (!this.itemId) this.qty = 0;
                            window.dispatchEvent(new CustomEvent('cart-toast', {
                                detail: { img: pImg, name: data.errors || 'Ошибка добавления', pid, type: 'error' },
                            }));
                            return;
                        }
                        this.maxReached = false;
                        if (data?.data?.item_id) this.itemId = data.data.item_id;
                        if (!qtySync) {
                            this.added = true;
                            setTimeout(() => { this.added = false; }, 5000);
                        }
                        this.updateBadge(data);
                        window.dispatchEvent(new CustomEvent('cart-toast', {
                            detail: { img: pImg, name: pName, pid, type: 'cart' },
                        }));
                    }
                } catch { /* silent */ }
                finally { this.loading = false; }
            },

            // POST save/?html=1 — обновить кол-во
            async postSave(newQty) {
                this.loading = true;
                try {
                    const res = await fetch(`${baseUrl}save/?html=1`, {
                        method: 'POST',
                        body: new URLSearchParams({
                            id: String(this.itemId),
                            quantity: String(newQty),
                        }),
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    });
                    if (res.ok) {
                        const data = await res.json().catch(() => null);
                        if (data?.status === 'fail') {
                            this.maxReached = true;
                            window.dispatchEvent(new CustomEvent('cart-toast', {
                                detail: { img: pImg, name: data.errors || 'Ошибка', pid, type: 'error' },
                            }));
                            if (data?.data?.q) this.qty = parseFloat(data.data.q);
                            return;
                        }
                        this.maxReached = false;
                        if (data?.data?.q) this.qty = parseFloat(data.data.q);
                        this.updateBadge(data);
                    }
                } catch { /* silent */ }
                finally { this.loading = false; }
            },

            // POST delete/?html=1 — удалить из корзины
            async postDelete() {
                this.loading = true;
                try {
                    const res = await fetch(`${baseUrl}delete/?html=1`, {
                        method: 'POST',
                        body: new URLSearchParams({ id: String(this.itemId) }),
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-Requested-With': 'XMLHttpRequest',
                        },
                    });
                    if (res.ok) {
                        const data = await res.json().catch(() => null);
                        this.itemId = null;
                        this.updateBadge(data);
                    }
                } catch { /* silent */ }
                finally { this.loading = false; }
            },

            updateBadge(data) {
                const count = data?.data?.count;
                if (count != null) window.updateCartBadges(count);
                else window.dispatchEvent(new Event('cart-updated'));
            },
        };
    });

    // ── cbCountdown — countdown timer for sale blocks ──
    Alpine.data('cbCountdown', (endDateStr) => {
        let _interval = null;
        const pad = n => String(n).padStart(2, '0');
        return {
            days: '00', hours: '00', minutes: '00', seconds: '00',
            expired: false,
            init() {
                if (!endDateStr) { this.expired = true; return; }
                const target = new Date(endDateStr).getTime();
                const tick = () => {
                    const diff = target - Date.now();
                    if (diff <= 0) {
                        this.expired = true;
                        this.days = '00'; this.hours = '00'; this.minutes = '00'; this.seconds = '00';
                        clearInterval(_interval);
                        return;
                    }
                    const d = Math.floor(diff / 86400000);
                    const h = Math.floor((diff % 86400000) / 3600000);
                    const m = Math.floor((diff % 3600000) / 60000);
                    const s = Math.floor((diff % 60000) / 1000);
                    this.days = pad(d); this.hours = pad(h); this.minutes = pad(m); this.seconds = pad(s);
                };
                tick();
                _interval = setInterval(tick, 1000);
            },
            destroy() { clearInterval(_interval); }
        };
    });

    // ── reviewDialog — review form popup on product page ──
    Alpine.data('reviewDialog', () => ({
        dialogOpen: false,
        rating: 0,
        sending: false,
        errors: [],
        success: false,

        submitReview(e) {
            this.errors = [];
            this.sending = true;
            const form = e.target;
            const fd = new FormData(form);
            fetch(form.action, { method: 'POST', body: fd })
                .then(r => r.json())
                .then(res => {
                    this.sending = false;
                    if (res.status === 'fail') {
                        this.errors = Array.isArray(res.errors) ? res.errors : Object.values(res.errors);
                        const ci = form.querySelector('.wa-captcha-img');
                        if (ci) {
                            ci.src = ci.src.replace(/\?.*$/, '?rid=' + Math.random());
                            const inp = form.querySelector('[name=captcha]');
                            if (inp) inp.value = '';
                        }
                    } else {
                        this.success = true;
                        try { this._prependReview(fd, res); } catch (err) { console.error('_prependReview:', err); }
                        form.reset();
                        this.rating = 0;
                        setTimeout(() => { this.dialogOpen = false; this.success = false; }, 2000);
                    }
                })
                .catch(() => {
                    if (!this.success) {
                        this.sending = false;
                        this.errors = ['Произошла ошибка. Попробуйте позже.'];
                    }
                });
        },

        _prependReview(fd, res) {
            const section = document.getElementById('product-reviews');
            if (!section) return;
            const empty = section.querySelector('.product-reviews__empty');
            if (empty) empty.remove();

            let list = section.querySelector('.product-reviews__list');
            if (!list) {
                list = document.createElement('div');
                list.className = 'product-reviews__list';
                const header = section.querySelector('.product-reviews__header');
                header.after(list);
            }

            const wrapper = document.createElement('div');
            wrapper.className = 'product-reviews__item';

            if (res && res.data && res.data.html) {
                wrapper.innerHTML = res.data.html;
            }

            list.insertBefore(wrapper, list.firstChild);
        }
    }));

    // ── productPage — SKU / qty / add-to-cart (shared: product.html + quick-view) ──
    Alpine.data('promoPopup', promoPopup);

    Alpine.data('productPage', () => {
        const config = window.__PRODUCT__ || {};
        const skus = config.skus || {};
        const currency = config.currency || {};
        const featuresMap = config.featuresSelectable || {};
        const ignoreStock = !!config.ignoreStockCount;
        const denominator = parseFloat(config.denominator) || 1;

        const isAvailable = (sku) => {
            if (sku.available === false) return false;
            if (ignoreStock) return true;
            const count = sku.count ?? null;
            return count === null || count > 0;
        };

        const initialSkuId = config.currentSkuId;
        const initialSku = skus[initialSkuId] || Object.values(skus)[0] || {};

        return {
            currentSkuId:       initialSkuId,
            currentPrice:       parseFloat(initialSku.price) || 0,
            currentComparePrice:parseFloat(initialSku.compare_price) || 0,
            currentArticle:     initialSku.sku || config.productSkuCode || '',
            currentAvailable:   isAvailable(initialSku),
            currentCount:       initialSku.count ?? null,
            currentMin:         parseFloat(initialSku.order_count_min) || 1,
            currentStep:        parseFloat(initialSku.order_count_step) || 1,
            quantity:           parseFloat(initialSku.order_count_min) || 1,
            added:              false,
            loading:            false,
            stockUnit:          config.stockUnit || '',
            baseUnit:           config.baseUnit || '',
            stockBaseRatio:     parseFloat(config.stockBaseRatio) || 0,
            selectedFeatures:   {},
            selectedFeatureTitles: {},
            selectedServices:   {},
            galleryIdx:         1,
            stickyVisible:      false,

            init() {
                window.addEventListener('gallery:slide', (e) => {
                    this.galleryIdx = e.detail;
                });

                // Sticky-bar: показываем, когда блок «В корзину» (actions-main) полностью
                // ушёл вверх за viewport. Scroll-listener надёжнее IO — не зависит от
                // x-show/display:none и batching'а IntersectionObserver.
                this.$nextTick(() => {
                    const actionsEl = document.querySelector('.product-cart__actions-main');
                    if (!actionsEl) return;
                    const update = () => {
                        this.stickyVisible = actionsEl.getBoundingClientRect().bottom < 0;
                    };
                    window.addEventListener('scroll', update, { passive: true });
                    window.addEventListener('resize', update);
                    update();
                });
                if (config.skuType === 1) {
                    document.querySelectorAll('.sku-feature').forEach(input => {
                        this.selectedFeatures[input.dataset.feature] = input.value;
                    });
                    document.querySelectorAll('.product-cart__feature-btn--active, .product-cart__color-option--active').forEach(btn => {
                        const code = btn.dataset.feature;
                        const title = btn.querySelector('.product-cart__feature-text')?.textContent?.trim() || btn.getAttribute('title') || btn.getAttribute('aria-label') || '';
                        if (code) this.selectedFeatureTitles[code] = title;
                    });
                }
                document.querySelectorAll('.product-cart__service').forEach((serviceEl) => {
                    const checkbox = serviceEl.querySelector('input[type="checkbox"][data-service-id]');
                    const select = serviceEl.querySelector('.product-cart__service-select');
                    if (!checkbox || !select) return;
                    select.disabled = !checkbox.checked;
                    if (checkbox.checked) {
                        const selectedOption = select.options[select.selectedIndex];
                        this.selectedServices[checkbox.dataset.serviceId] = parseFloat(selectedOption?.dataset.price) || 0;
                    }
                });
            },

            scrollTop() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },

            stickyAddToCart() {
                // Вызываем addToCart напрямую с той же формой — тот же productPage scope,
                // тот же currentSkuId/quantity/services. Надёжнее чем requestSubmit,
                // который в некоторых сценариях не триггерит Alpine @submit.
                const form = document.querySelector('.product-cart__form');
                if (!form) return;
                this.addToCart({ target: form, preventDefault() {} });
            },

            get formattedPrice() { return this.formatCurrency(this.totalPrice); },
            get formattedComparePrice() {
                if (this.currentComparePrice <= 0) return '';
                return this.formatCurrency(this.currentComparePrice);
            },
            get discountPercent() {
                if (this.currentComparePrice <= 0) return '';
                const pct = Math.round((this.currentComparePrice - this.currentPrice) / this.currentComparePrice * 100);
                return `\u2212${pct}%`;
            },
            get totalPrice() {
                let total = this.currentPrice;
                for (const key in this.selectedServices) total += this.selectedServices[key];
                return total;
            },
            get formattedBasePrice() {
                if (!this.stockBaseRatio) return '';
                return this.formatCurrency(this.currentPrice / this.stockBaseRatio);
            },

            get formattedTotalPrice() {
                return this.formatCurrency(this.totalPrice * this.quantity);
            },

            get stockState() {
                if (!this.currentAvailable) return 'out';
                if (this.currentCount !== null && this.currentCount > 0 && this.currentCount <= 10) return 'low';
                return 'in';
            },

            get stockLabel() {
                if (this.stockState === 'out') return 'Нет в наличии';
                if (this.stockState === 'low') return 'Осталось мало';
                return 'В наличии';
            },

            get installmentText() {
                const inst = config.installment || {};
                if (!inst.enabled) return '';
                if (inst.mode === 'formula') {
                    const months = parseInt(inst.months) || 12;
                    if (months <= 0) return inst.text || '';
                    const perMonth = Math.round((this.totalPrice * this.quantity) / months);
                    return (inst.prefix ? inst.prefix + ' ' : '') + this.formatCurrency(perMonth).replace(/[^\d\s,.]/g, '').trim() + (inst.suffix ? ' ' + inst.suffix : '');
                }
                return inst.text || '';
            },

            isFeatureValueAvailable(featureCode, valueId) {
                if (!featuresMap || !Object.keys(featuresMap).length) return true;
                let key = '';
                document.querySelectorAll('.sku-feature').forEach(input => {
                    const f = input.dataset.feature;
                    const v = (f == featureCode) ? String(valueId) : input.value;
                    key += f + ':' + v + ';';
                });
                const match = featuresMap[key];
                if (!match) return false;
                const fullSku = skus[match.id] || match;
                return isAvailable(fullSku);
            },

            selectFeature(featureCode, value, btnEl) {
                this.selectedFeatures[featureCode] = value;
                this.selectedFeatureTitles[featureCode] = btnEl.querySelector('.product-cart__feature-text')?.textContent?.trim() || btnEl.getAttribute('title') || btnEl.getAttribute('aria-label') || value;
                const hiddenInput = document.querySelector(`.sku-feature[data-feature="${featureCode}"]`);
                if (hiddenInput) hiddenInput.value = value;
                const parent = btnEl.closest('.product-cart__feature-values');
                if (parent) {
                    parent.querySelectorAll('.product-cart__feature-btn').forEach(btn => {
                        btn.classList.toggle('product-cart__feature-btn--active', btn === btnEl);
                    });
                    parent.querySelectorAll('.product-cart__color-option').forEach(btn => {
                        btn.classList.toggle('product-cart__color-option--active', btn === btnEl);
                    });
                }
                this.lookupSkuByFeatures();
            },

            lookupSkuByFeatures() {
                let key = '';
                document.querySelectorAll('.sku-feature').forEach(input => {
                    key += input.dataset.feature + ':' + input.value + ';';
                });
                const match = featuresMap[key];
                if (match) {
                    this.currentSkuId = match.id;
                    const fullSku = skus[match.id];
                    // compare_price отсутствует в sku_features_selectable — fallback на полный SKU.
                    this.currentPrice = parseFloat(match.price) || parseFloat(fullSku?.price) || 0;
                    this.currentComparePrice = parseFloat(fullSku?.compare_price) || parseFloat(match.compare_price) || 0;
                    if (fullSku) {
                        this.currentCount = fullSku.count ?? null;
                        this.currentMin   = parseFloat(fullSku.order_count_min) || 1;
                        this.currentStep  = parseFloat(fullSku.order_count_step) || 1;
                        this.stockBaseRatio = parseFloat(fullSku.stock_base_ratio) || 0;
                    } else {
                        this.currentCount = match.count ?? null;
                    }
                    this.currentArticle = (fullSku && fullSku.sku) || match.sku || config.productSkuCode || '';
                    this.$dispatch('product-sku-changed', { article: this.currentArticle });
                    this.currentAvailable = isAvailable(fullSku || match);
                    this.quantity = this.currentMin;
                    if (match.image_id && window.__productGallery) window.__productGallery.slideTo(match.image_id);
                } else {
                    this.currentAvailable = false;
                    this.currentCount = 0;
                }
                this.added = false;
            },

            selectSku(radioEl) {
                const skuId = parseInt(radioEl.value);
                this.currentSkuId = skuId;
                this.currentPrice = parseFloat(radioEl.dataset.price) || 0;
                this.currentComparePrice = parseFloat(radioEl.dataset.comparePrice) || 0;
                const fullSku = skus[skuId];
                if (fullSku) {
                    this.currentCount = fullSku.count ?? null;
                    this.currentMin   = parseFloat(fullSku.order_count_min) || 1;
                    this.currentStep  = parseFloat(fullSku.order_count_step) || 1;
                    this.stockBaseRatio = parseFloat(fullSku.stock_base_ratio) || 0;
                } else {
                    const raw = radioEl.dataset.count;
                    this.currentCount = raw !== '' && raw != null ? parseInt(raw) : null;
                }
                this.currentArticle = (fullSku && fullSku.sku) || config.productSkuCode || '';
                this.$dispatch('product-sku-changed', { article: this.currentArticle });
                this.currentAvailable = fullSku
                    ? isAvailable(fullSku)
                    : (!radioEl.disabled && (ignoreStock || this.currentCount === null || this.currentCount > 0));
                this.quantity = this.currentMin;
                document.querySelectorAll('.product-cart__sku-item').forEach(item => {
                    item.classList.toggle('product-cart__sku-item--active', item.querySelector('input')?.value == radioEl.value);
                });
                if (parseInt(radioEl.dataset.imageId) && window.__productGallery) {
                    window.__productGallery.slideTo(parseInt(radioEl.dataset.imageId));
                }
                this.added = false;
            },

            incrementQty() {
                if (!this.currentAvailable) return;
                const qty = +this.quantity || this.currentMin;
                const max = (ignoreStock || !this.currentCount) ? 9999 : this.currentCount;
                let next = +(qty + this.currentStep).toFixed(4);
                if (denominator !== 1) next = Math.round(next / denominator) * denominator;
                if (next <= max) this.quantity = +next.toFixed(4);
            },

            decrementQty() {
                if (!this.currentAvailable) return;
                const qty = +this.quantity || this.currentMin;
                let prev = +(qty - this.currentStep).toFixed(4);
                if (denominator !== 1) prev = Math.round(prev / denominator) * denominator;
                if (prev >= this.currentMin) this.quantity = +prev.toFixed(4);
            },

            toggleService(el) {
                const serviceId = el.dataset.serviceId;
                const select = el.closest('.product-cart__service')?.querySelector('.product-cart__service-select');
                if (el.checked) {
                    if (select) select.disabled = false;
                    const price = select
                        ? parseFloat(select.options[select.selectedIndex]?.dataset.price) || 0
                        : parseFloat(el.dataset.price) || 0;
                    this.selectedServices[serviceId] = price;
                } else {
                    if (select) select.disabled = true;
                    delete this.selectedServices[serviceId];
                }
            },

            updateServiceVariant(selectEl) {
                const serviceId = selectEl.dataset.serviceId;
                const checkbox = selectEl.closest('.product-cart__service')?.querySelector(`input[data-service-id="${serviceId}"]`);
                if (checkbox?.checked) {
                    this.selectedServices[serviceId] = parseFloat(selectEl.options[selectEl.selectedIndex]?.dataset.price) || 0;
                }
            },

            async addToCart(event) {
                if (!this.currentAvailable || this.loading) return;
                const form = event.target;
                const formData = new FormData(form);
                formData.set('sku_id', this.currentSkuId);
                formData.set('quantity', this.quantity);
                this.loading = true;
                try {
                    const response = await fetch(form.action, {
                        method: 'POST',
                        body: formData,
                        headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    });
                    if (response.ok) {
                        const data = await response.json().catch(() => null);
                        if (data?.status === 'fail') {
                            window.dispatchEvent(new CustomEvent('cart-toast', {
                                detail: { name: data.errors || 'Ошибка добавления', type: 'error' },
                            }));
                            return;
                        }
                        this.added = true;
                        if (data?.data?.count != null) window.updateCartBadges(data.data.count);
                        window.dispatchEvent(new CustomEvent('cart-toast', {
                            detail: {
                                img:  form.dataset.pimg  || '',
                                name: form.dataset.pname || '',
                                pid:  form.dataset.pid   || '',
                                type: 'cart',
                            },
                        }));
                        setTimeout(() => { this.added = false; }, 5000);
                    }
                } catch { /* silent */ }
                finally { this.loading = false; }
            },

            formatCurrency(amount) {
                const sep = currency.thousands_sep || ' ';
                const dec = currency.decimal_point || ',';
                const precision = parseInt(currency.frac_digits ?? currency.precision) || 0;
                const raw = currency.sign_html || currency.sign || '₽';
                const sign = raw.replace(/<[^>]*>/g, '');
                const signDelim = currency.sign_delim ?? ' ';
                let i = parseInt(amount = (+amount || 0).toFixed(precision)) + '';
                const j = i.length > 3 ? i.length % 3 : 0;
                const km = j ? i.substr(0, j) + sep : '';
                const kw = i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + sep);
                const kd = precision && (amount - i)
                    ? dec + Math.abs(amount - i).toFixed(precision).replace(/-/, 0).slice(2) : '';
                const number = km + kw + kd;
                return currency.sign_position ? number + signDelim + sign : sign + signDelim + number;
            },
        };
    });

});

function promoPopup({ delay = 5, deadline = '', cookieName = 'promo_popup_seen' }) {
    return {
        visible: false,
        timeLeft: { total: 0, hours: 0, minutes: 0, seconds: 0 },
        _countdown: null,

        init() {
            if (document.cookie.split(';').some(c => c.trim().startsWith(cookieName + '='))) return;
            setTimeout(() => {
                this.visible = true;
                if (deadline) this._startCountdown(deadline);
            }, delay * 1000);
        },

        close() {
            this.visible = false;
            const exp = new Date(Date.now() + 86400000).toUTCString();
            document.cookie = cookieName + '=1;expires=' + exp + ';path=/';
            if (this._countdown) clearInterval(this._countdown);
        },

        _startCountdown(deadlineStr) {
            const update = () => {
                const total = Math.max(0, new Date(deadlineStr) - Date.now());
                this.timeLeft = {
                    total,
                    hours: Math.floor(total / 3600000),
                    minutes: Math.floor((total % 3600000) / 60000),
                    seconds: Math.floor((total % 60000) / 1000),
                };
                if (total === 0) clearInterval(this._countdown);
            };
            update();
            this._countdown = setInterval(update, 1000);
        },
    };
}
